import { useSelector } from 'react-redux';
import useIsOverCharacterLimit from './useIsOverCharacterLimit';

// True when auto-save is on AND the project exceeds the character limit: the
// project can't be persisted in that state (auto-save reports BLOCKED), so any
// DB-touching action (synthesis) must be disabled in the UI.
const useIsAutoSaveOverLimit = () => {
  const autoSaveEnabled = useSelector((s) => s.project.autoSaveEnabled);
  const isOverLimit = useIsOverCharacterLimit();
  return autoSaveEnabled && isOverLimit;
};

export default useIsAutoSaveOverLimit;
